<template>
  <div>
    <v-btn
      v-if="canSubmit"
      class="mr-3 text-capitalize"
      color="primary"
      flat
      :loading="isSubmitting"
      :disabled="loading"
      @click="emit('submitted')"
      >Submit</v-btn
    >

    <GuardReportActionsMenuBtn
      :report-state="ReportStateEnum.Draft"
      :disabled="loading || isSubmitting"
      :loading="loading"
      @edit-report-pressed="emit('edit-report-pressed')"
      @delete-report-pressed="emit('delete-report-pressed')"
      @report-coordinates-pressed="emit('report-coordinates-pressed')"
    />
  </div>
</template>

<script setup lang="ts">
import { ReportStateEnum } from '@/models/report'

import GuardReportActionsMenuBtn from './GuardReportActionsMenuBtn.vue'

interface Props {
  canSubmit: boolean
  loading: boolean
  isSubmitting?: boolean
}
defineProps<Props>()

interface Emit {
  (e: 'submitted'): void
  (e: 'edit-report-pressed'): void
  (e: 'delete-report-pressed'): void
  (e: 'report-coordinates-pressed'): void
}
const emit = defineEmits<Emit>()
</script>
